import Swal from 'sweetalert2/dist/sweetalert2.js'
import { $, $$ } from '@/utilities/helpers';

let $frequencies = $$('.js-select-frequency');

if ($frequencies) {
    $frequencies.forEach($frequency => {

        $frequency.addEventListener('click', () => {
            if ($frequency.classList.contains('selected')) return;
            let frequency = $frequency.getAttribute('data-frequency');
            $frequencies.forEach($frequency => $frequency.classList.remove('selected'));
            $frequency.classList.add('selected');
            $('.subscriptions').classList = `subscriptions ${frequency}`;


            updateLinks(frequency);
        });

    });
}

function updateLinks(frequency) {
    let $selectPlanButtons = $$('.js-select-plan');

    if ($selectPlanButtons) {
        $selectPlanButtons.forEach($selectPlanButton => {

            let link = $selectPlanButton.getAttribute('href');
            let newLink = link.replace(/(monthly|annual)/, frequency);

            $selectPlanButton.setAttribute('href', newLink);

        });

    }

}


let $selectPlanButtons = $$('.js-select-plan');

if ($selectPlanButtons) {
    $selectPlanButtons.forEach($selectPlanButton => {

        let $plan = $selectPlanButton.closest('.js-plan');

        $selectPlanButton.addEventListener('click', (e) => {
            e.preventDefault();

            if ($plan.classList.contains('selected')) return;


        });

    });
}